import { useQuery } from "@tanstack/react-query";
import { AmbientConversation } from "../api/ambientConversation.type";
import { getAmbientConversations } from "../api/ambientConversations.api";
import { useAuth } from "./AuthContext";

export const useLoadAmbientConversations = () => {
  const { user } = useAuth();
  const {
    data: conversations = [],
    isLoading,
    isError,
    error,
    refetch,
  } = useQuery<AmbientConversation[]>({
    queryKey: ["ambient-conversations", user?.id],
    queryFn: getAmbientConversations,
    enabled: !!user,
    refetchOnWindowFocus: true,
  });

  return {
    conversations,
    isLoading,
    isError,
    error,
    refetchConversations: refetch,
  };
};

export const useLoadAmbientConvos = () => useLoadAmbientConversations();
